import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RefComponent } from './ref.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [RefComponent],
  exports: [RefComponent]
})
export class RefModule {}
